import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import AddPhoneModal from '@/shared/components/channels/AddPhoneModal.vue';
import { useOrganisationSearch } from '@/modules/organisation/public';
import { addContactPhone } from '../../infrastructure/adapters/contactService';
import { autoCreateOrganisationRelation } from '../../infrastructure/api/contactRelationsApi';
import { logger } from '@/infrastructure/services/LoggerService';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactAddPhoneModal',
    props: /*@__PURE__*/ _mergeModels({
        contactId: {},
        hasPrimaryPhone: { type: Boolean },
        contactName: {},
        existingRelationOrgIds: {}
    }, {
        "modelValue": { type: Boolean, ...{ default: false } },
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["created"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        /**
         * Contact binding of the reusable {@link AddPhoneModal} (OP-5604 / US-07).
         *
         * Injects the contact-specific persistence (`addContactPhone`). Runs in context
         * mode so the Personnel/Professionnel toggle + organisation anchor (OP-5646) are
         * shown, mirroring {@link ContactAddEmailModal}.
         */
        const organisationSearch = useOrganisationSearch();
        const props = __props;
        const open = _useModel(__props, "modelValue");
        const emit = __emit;
        // errorCode → i18n key (R70). All codes are wire contracts guarded client-side
        // (context radio + required organisation for OP-5646; the Mobile/Fixe Type is always
        // sent on a Phone channel; the phone field length-checks per country), so they only
        // fire as defense-in-depth — the generic fallback covers everything else.
        const ERROR_OVERRIDES = {
            CHANNEL_USAGE_CONTACT_ONLY: 'contact.detail.addPhone.errors.usageInvalid',
            CHANNEL_LINKED_ORG_REQUIRES_PROFESSIONAL: 'contact.detail.addPhone.errors.linkedOrgRequiresProfessional',
            CHANNEL_SUBTYPE_PHONE_ONLY: 'contact.detail.addPhone.errors.subTypePhoneOnly',
            // OP-6089: BE rejects too-short/too-long/unparseable numbers (IsPossibleNumber) with this code.
            'CommunicationChannel.Phone.Invalid': 'contact.detail.addPhone.errors.phoneInvalid',
        };
        async function submitPhone(payload) {
            const channelId = await addContactPhone(props.contactId, {
                value: payload.value,
                subType: payload.subType,
                isPrimary: payload.isPrimary,
                // `withContext` guarantees usage is populated; fall back defensively.
                usage: payload.usage ?? 'Professional',
                linkedOrganisationId: payload.linkedOrganisationId,
            });
            // OP-5603 amendment (09/06/2026): auto-create a contact↔organisation relation when
            // a Professional phone is anchored to an organisation (mirrors ContactAddEmailModal).
            // Best-effort: a failure must not surface to the user — the channel was already persisted.
            if (payload.usage === 'Professional' && payload.linkedOrganisationId) {
                try {
                    await autoCreateOrganisationRelation(props.contactId, payload.linkedOrganisationId);
                }
                catch (err) {
                    logger.error(`Auto-relation creation failed after phone channel save for contact ${props.contactId}`, err);
                }
            }
            return channelId;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(AddPhoneModal, {
                modelValue: open.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((open).value = $event)),
                "has-primary-phone": __props.hasPrimaryPhone,
                "with-context": true,
                "organisation-search": _unref(organisationSearch),
                "owner-name": __props.contactName,
                submit: submitPhone,
                "error-overrides": ERROR_OVERRIDES,
                "existing-relation-org-ids": __props.existingRelationOrgIds,
                "i18n-prefix": "contact.detail.addPhone",
                onCreated: _cache[1] || (_cache[1] = ($event) => (emit('created')))
            }, null, 8 /* PROPS */, ["modelValue", "has-primary-phone", "organisation-search", "owner-name", "existing-relation-org-ids"]));
        };
    }
});
